var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 13.2714C23.52 12.4485 23.4464 11.6272 23.3 10.8174H12V15.4594H18.458C18.3244 16.1937 18.0433 16.8932 17.6316 17.5158C17.22 18.1383 16.6863 18.6709 16.063 19.0814V22.0924H19.941C21.1221 20.955 22.051 19.5821 22.6674 18.0627C23.2838 16.5432 23.5739 14.9112 23.519 13.2724L23.52 13.2714Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 24.9993C14.9206 25.0787 17.7617 24.0387 19.9414 22.0923L16.0634 19.0813C15.1357 19.6767 14.0843 20.0524 12.9894 20.1798C11.8945 20.3072 10.7849 20.1829 9.74534 19.8163C8.70575 19.4498 7.76358 18.8507 6.99066 18.0648C6.21775 17.2789 5.6345 16.3268 5.28539 15.2812H1.27539V18.3903C2.27472 20.3776 3.80676 22.048 5.70045 23.2151C7.59415 24.3821 9.77496 24.9998 11.9994 24.9993Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28534 15.2784C4.7835 13.7998 4.7835 12.197 5.28534 10.7184V7.60938H1.27634C0.437054 9.28181 0 11.1272 0 12.9984C0 14.8696 0.437054 16.7149 1.27634 18.3874L5.28534 15.2784Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 5.77183C13.705 5.74338 15.3531 6.38832 16.5864 7.56683L20.0284 4.12383C17.8562 2.08406 14.9789 0.96417 11.9994 0.998828C9.77475 0.998435 7.59379 1.61645 5.70008 2.78387C3.80636 3.95128 2.27444 5.62214 1.27539 7.60983L5.28439 10.7188C5.74556 9.29547 6.64151 8.05259 7.84612 7.16515C9.05072 6.27771 10.5033 5.7904 11.9994 5.77183Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ab88174fe7ba71aaabf49b205ce66912.svg";
export { ForwardRef as ReactComponent };